export default {
  version: 'master',
  compilation: '280322'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1477
// module chunks = 22